import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { SignInWithGooglePlugin } from './definitions';
import { CAPACITOR_SIGN_IN_WITH_GOOGLE_PLUGIN_NAME } from '../pluginConstants';

const SignInWithGoogleRaw = registerPlugin<SignInWithGooglePlugin>(CAPACITOR_SIGN_IN_WITH_GOOGLE_PLUGIN_NAME);
const SignInWithGoogle = withBridgedStackTrace(SignInWithGoogleRaw, CAPACITOR_SIGN_IN_WITH_GOOGLE_PLUGIN_NAME);

export * from './definitions';
export { SignInWithGoogle };
